module.exports = __webpack_public_path__ + "media/images/img-btn-data-0881303a048b5a1c860265e168151df7.svg";